import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BillingPortalProps } from '../../models/BillingPortalProps';
import { InvoicesService } from '../../services/invoices.service';
import { SessionStorageService } from '../../services/session-storage.service';
import { environment } from '../../../environments/environment';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AciPaymentService } from '../../invoices/payments/aci-payment.service';
import { BansStorageService } from '../../services/bans-storage.service';

@Component({
  selector: 'ngbd-modal-content',
  template: `
      <div class="modal-body text-center ac-success-msg" [style.display]="success?success:'none'">
      <i class="las la-check-circle fs-48"></i>
      <p><svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M31 0C13.95 0 0 13.95 0 31C0 48.05 13.95 62 31 62C48.05 62 62 48.05 62 31C62 13.95 48.05 0 31 0ZM24.8 46.5L9.3 31L13.671 26.629L24.8 37.727L48.329 14.198L52.7 18.6L24.8 46.5Z" fill="#168007"/>
    </svg></p>
      <h2>{{action}} Successfully!</h2>
        <p class="ac-modelpara">{{name}}</p>
      </div>
      <div class="modal-body text-center ac-error-msg" [style.display]="error?error:'none'">
      <i class="las la-times-circle fs-48"></i>
      <p><svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M36 0C55.908 0 72 16.092 72 36C72 55.908 55.908 72 36 72C16.092 72 0 55.908 0 36C0 16.092 16.092 0 36 0ZM48.924 18L36 30.924L23.076 18L18 23.076L30.924 36L18 48.924L23.076 54L36 41.076L48.924 54L54 48.924L41.076 36L54 23.076L48.924 18Z" fill="#D30000"/>
    </svg></p>
      <h2> Error!</h2>
        <p class="ac-modelpara">{{name}}</p>
      </div>
      <div class="modal-footer ac-modelfooter mb-4">
        <button type="button" class="btn btn-outline-dark ac-btn-outline-primary ac-butncancel display-block text-center" (click)="closed()">Close</button>
      </div>
    `
})
export class NgbdModalContent {
  @Input() name: any;
  @Input() status: any;
  @Input() success: any = "none";
  @Input() error: any = "none";
  @Input() className: any;
  @Input() action: any;
  isPayClicked: boolean = false;
  supportLanguages = ['en'];
  constructor(public activeModal: NgbActiveModal,
    public translate: TranslateService) {

   /* this.translate.addLangs(this.supportLanguages);
    this.translate.setDefaultLang('en');

    const browserLang = translate.getBrowserLang();
    var lang = browserLang?.match(/en|fr/) ? browserLang : 'en';
    translate.use(lang);*/
  }
  closed() {
    this.activeModal.close();
    window.location.reload();
    //parent.location = location.ancestorOrigins.item(0)?.toString()+"/invoices" || "/invoices";
  }

}

@Component({
  selector: 'ngbd-modal-confirm',
  template: `
      <div class="modal-header" >
          <h4 class="modal-title" id="modal-title">Disable Recurring Payment</h4>
          <button
              type="button"
              class="btn-close"
              aria-describedby="modal-title"
              (click)="cancel()"
          ></button>
      </div>
      <div class="modal-body">
          <p>
              <strong>Are you sure you want to Disable Recurring Payment?</strong>
          </p>
      </div>
      <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
          <button type="button" class="btn btn-danger" (click)="deleteRecurring()">Ok</button>
      </div>
  `,
  styles: [`
      ::ng-deep .modal {
          --bs-modal-zindex: 1055;
          --bs-modal-width: 500px;
          --bs-modal-padding: 1rem;
          --bs-modal-margin: 0.5rem;
          --bs-modal-bg: #fff;
          --bs-modal-border-color: var(--bs-border-color-translucent);
          --bs-modal-border-width: 1px;
          --bs-modal-border-radius: 0.5rem;
          --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
          --bs-modal-inner-border-radius: calc(0.5rem - 1px);
          --bs-modal-header-padding-x: 1rem;
          --bs-modal-header-padding-y: 1rem;
          --bs-modal-header-padding: 1rem 1rem;
          --bs-modal-header-border-color: var(--bs-border-color);
          --bs-modal-header-border-width: 1px;
          --bs-modal-title-line-height: 1.5;
          --bs-modal-footer-gap: 0.5rem;
          --bs-modal-footer-bg: ;
          --bs-modal-footer-border-color: var(--bs-border-color);
          --bs-modal-footer-border-width: 1px;
          position: fixed;
          top: 50%;
          left: 50%;
          z-index: var(--bs-modal-zindex);
          display: none;
          width: 100%;
          height: 100%;
          overflow-x: hidden;
          overflow-y: auto;
          outline: 0;
          background:none;
      }
  `]
})

export class NgbdModalConfirm {

	modal = inject(NgbActiveModal);
  @Input() banNo: any;
  @Input() confirmationCode: any;

  constructor(
    private aciPaymentService: AciPaymentService,
    private modalService: NgbModal
  ) {}

  deleteRecurring() {
    this.aciPaymentService.showLoader = true;
    this.modal.close();
    this.aciPaymentService.deleteRecurring(this.banNo, this.confirmationCode).subscribe(
      (data:any) => {
        console.log("Recurring Schedule deleted");
        this.open("Success", "Delete Recurring Schedule Successfull");
        this.aciPaymentService.showLoader = false;
      },
      (error: any) => {
        this.aciPaymentService.showLoader = false;
        console.error("Error deleting recurring", error);
        this.open("Error", "Error While Deleting Recurring Schedule");
      }
    );
  }

  cancel() {
    window.location.reload();
  }

  open(status: any, message: any) {
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.action = "Deleted Recurring";
    if (status == "Success") {
      modalRef.componentInstance.name = message;
      modalRef.componentInstance.success = "block";
      modalRef.componentInstance.error = "none";
    } else {
      //modalRef.componentInstance.name =this.translate.instant("ASM.Invoices.error."+message);
      modalRef.componentInstance.name = message;
      modalRef.componentInstance.success = "none";
      modalRef.componentInstance.error = "block";
    }
  }

}

export class RecurringSchedule {
  confirmationCode!: String;
  paymentId!:String;
  defaultPaymentMethodId!: String;
  isRecurring: boolean = false;
  oldRecurring: boolean = false;
  paymentMethods: Array<PaymentMethods> = new Array<PaymentMethods>();
}

export class PaymentMethods {
  paymentAuthId!: String;
  truncatedDda!: String;
  paymentType!: String;
  cardNumber!: String;
  creditAccount!: String;
  paymentChannelKind: String = "Web";
  debitName!: String;
  type!:String;
  recurringMethod!:String;
}

@Component({
  selector: 'app-recurring',
  templateUrl: './recurring.component.html',
  styleUrls: ['./recurring.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class RecurringComponent implements AfterViewInit {
  url: any;
  @Input()
  data:any;
  banCAs = new Map<string, Array<string>>();
  ban: string = history.state.ban;
  //showLoader: boolean = true;

  BillingPortalProps: BillingPortalProps = new BillingPortalProps();
  customerIDs: Array<string> = [];
  banflag: boolean = false;

  recurringSchedule = new Map<string, RecurringSchedule>();
  cardFlag:boolean = false;

  isVisible:boolean = false;
  showPaymentMethods : boolean = false;
  isRecurringFlagDisable = true;
  banNo = "";
  confirmationCode = "";
  openConfirmationModel = "";
  isPaymentMethodAvailable: boolean = false;
  isPaymentMethodsAPICall: boolean = false;
  isNewPaymentExperienceEnabled: boolean = environment.newPaymentExperienceEnableFlag;

  constructor(private sanitizer: DomSanitizer,
    private invoicesService: InvoicesService,
    private modalService: NgbModal,
    private storageService: SessionStorageService, 
    private sessStorage: SessionStorageService,
    public aciPaymentService: AciPaymentService,
    private bansService: BansStorageService
   ) {
  }
  async ngOnInit(): Promise<void> {
    this.aciPaymentService.showLoader = true;
    this.apigeeToken = await this.sessStorage.getItem<string>("apigeeToken-bp");
      
    if (window.addEventListener) {
      window.addEventListener("message", this.onIFrameLoaded.bind(this), true);
    }
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(environment.serverFURL + "invoices/speedframe?original="+window.origin+"&ban="+this.ban+"&callbackurl=/invoices/process-recurring");
  }

  async ngAfterViewInit(): Promise<void> {
    this.getBans();
  }

  getBans() {
    this.bansService.bans.subscribe((bans: any) => {
      if (bans) {
        this.banCAs = bans;
        let ban = JSON.parse(JSON.stringify(localStorage.getItem("Selected_BAN_Dropdown_Value"))) || "";
        let firstBAN: any = this.banCAs.entries().next().value;
        this.ban = ban ? ban : firstBAN[0];
        this.fetchPaymentMethods(this.ban);
      }else{
        this.bansService.banFlag.subscribe(
          (isPresent: boolean) => {
            if(!isPresent){
              this.aciPaymentService.showLoader = false;
            }
          }
        );
      }
    })
  }

  selectBan(selectedBan: string): void {
    this.ban = selectedBan;
    if (this.ban != "BAN") {
      this.showPaymentMethods = false;
      if (window.addEventListener) {
        window.addEventListener("message", this.onIFrameLoaded.bind(this), true);
      }
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(environment.serverFURL + "invoices/speedframe?original="+window.origin+"&ban="+this.ban+"&callbackurl=/invoices/process-recurring");
      this.fetchPaymentMethods(this.ban);
    }
  }

  // res :any;
  async fetchPaymentMethods(ban: any) {
    this.aciPaymentService.showLoader = true;
    this.cardFlag = false;
   var cardData = new RecurringSchedule();
    this.recurringSchedule = new Map<string, RecurringSchedule>();
    (await this.invoicesService.getRecurringSchedule(ban)).subscribe((flag:any)=>{
      if(flag.status == "Inactive"){
        cardData.isRecurring = false;
        cardData.oldRecurring = false;
        this.isRecurringFlagDisable = true;
      }else{
        cardData.isRecurring = true;
        cardData.oldRecurring = true;
        this.isRecurringFlagDisable = false;
      }
      this.openConfirmationModel = flag.status;
      this.banNo = ban;
      this.confirmationCode = flag.confirmationCode;
      
      cardData.confirmationCode = flag.confirmationCode;
      cardData.paymentId = flag.paymentMethodId;
    });
  
    
   await this.invoicesService.getPaymentMethods(ban).subscribe((res:any) =>{
      res && res.paymentMethods && res.paymentMethods.forEach((element: any) => {
        var card = new PaymentMethods();
        card.cardNumber = element.cardNumber;
        card.paymentAuthId = element.id;
        card.type = element.paymentType.toUpperCase();
        card.paymentType = element.paymentType.toUpperCase()=="ACH" ? element.type :element.creditCardType;
        card.truncatedDda = element.truncatedDda;
        card.creditAccount = ban;
        card.debitName = element.accountHolderInfo.accountHolderName;
        
        if(cardData.isRecurring){
          var id = card.paymentAuthId.replaceAll("-","").toUpperCase();
      
          if(id === cardData.paymentId || card.paymentAuthId.toUpperCase() ===  cardData.paymentId){
              cardData.defaultPaymentMethodId = card.paymentType + "-" + (card.type  == 'ACH' ? card.truncatedDda : card.cardNumber); 
              card.recurringMethod = cardData.defaultPaymentMethodId ;
          }
          cardData.paymentMethods.push(card);
          }
        else {
          if (res.defaultPaymentMethodId === card.paymentAuthId) {
            cardData.paymentId = res.defaultPaymentMethodId;
            cardData.defaultPaymentMethodId = card.paymentType + "-" + (card.type == 'ACH' ? card.truncatedDda : card.cardNumber);
        }
        cardData.paymentMethods.push(card);
      }
      let formattedMethodId = element.id.replace(/-/g, '').toUpperCase();
      if(formattedMethodId == cardData.paymentId){
        this.isPaymentMethodAvailable = true;
      }
      });
      this.aciPaymentService.showLoader= false;
      this.cardFlag = true;
    },(err)=>{
      this.aciPaymentService.showLoader= false;
      this.cardFlag = true;
    });
    this.recurringSchedule.set(ban,cardData);
    console.log(this.recurringSchedule);

  }

  SelectedMethod(bans: any, methods: any) {
    var value = methods.paymentType + "-" + (methods.type == "ACH" ? methods.truncatedDda : methods.cardNumber);
    var currentSchedule = bans.value;
    if(methods.recurringMethod == value || !currentSchedule.isRecurring){
      this.isVisible = false;
    }else{
      this.isVisible = true;
    }
    currentSchedule.paymentId = methods.paymentAuthId;
    currentSchedule.defaultPaymentMethodId = value;
    this.recurringSchedule.set(bans.key, currentSchedule);
    return;

  }

  open(status: any, message: any) {
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.action = "Scheduled Recurring";
    if (status == "Success") {
      modalRef.componentInstance.name = message;
      modalRef.componentInstance.success = "block";
      modalRef.componentInstance.error = "none";
    } else {
      //modalRef.componentInstance.name =this.translate.instant("ASM.Invoices.error."+message);
      modalRef.componentInstance.name = message;
      modalRef.componentInstance.success = "none";
      modalRef.componentInstance.error = "block";
    }
  }

  changeRecurring(value:RecurringSchedule){
    if(value.defaultPaymentMethodId && !this.isVisible){
      this.isVisible = true;
    }else{
      this.isVisible = false;
    }

  }

  apigeeToken: any;

  @ViewChild('myDiv')
  myDiv!: ElementRef;

  onIFrameLoaded($event: any) {
    window.removeEventListener("message", this.onIFrameLoaded, true);
    if($event.data === 'FrameLoaded') {
      console.log("Element--"+ this.myDiv && this.myDiv.nativeElement)
      let iframe = this.myDiv && this.myDiv.nativeElement as HTMLIFrameElement;
      if(iframe.contentWindow) {
        let billingProps = environment.billingProps;
        var azureClientID = billingProps.aud;
        let msalKeys = localStorage.getItem(`msal.token.keys.${azureClientID}`);
        let accessToken = JSON.parse(msalKeys??"{}").accessToken[0];
        var requestData ={
              ban : this.ban,
              BillingPortalProps : billingProps,
              msalKeys : msalKeys,
              azureTokenData: localStorage.getItem(accessToken),
              apigeeToken :this.apigeeToken
            }
            // this.sessStorage.getItem<string>("apigeeToken-bp")
        iframe.contentWindow.postMessage(requestData, environment.serverFURL);
      }
    }
  }

  async showIframe(){
    this.showPaymentMethods= true;

    if (window.addEventListener) {
      console.log("Event Added")
      window.addEventListener("message", this.onIFrameLoaded.bind(this), true);
    }
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(environment.serverFURL + "invoices/speedframe?original="+window.origin+"&ban="+this.ban+"&callbackurl=/invoices/process-recurring");
 
  }

  openConfirmation() {

    if (this.openConfirmationModel == "Active") {
      const modalRef = this.modalService.open(NgbdModalConfirm);
      modalRef.componentInstance.banNo = this.banNo;
      modalRef.componentInstance.confirmationCode = this.confirmationCode;
    }
	}

  updateShowLoader(value: any) {
    console.log("coming here");
    this.aciPaymentService.showLoader = value;
  }

}
  
